import {getLocalStorage, setLocalStorage} from '@/utils/main';
import {useState} from 'react';

const STREAMER_FILTER_KEY = 'isFilteredMyFeedOnlyStreamer';

/**
 * 스트리머 글만 보기 상태값을 로컬스토리지에 저장
 */
export const useStreamerPostFilter = () => {
  const getStreamerFilterKey = () => getLocalStorage(STREAMER_FILTER_KEY, '');
  const [streamerPostFilter, setStreamerPostFilter] =
    useState(getStreamerFilterKey);

  const toggleFilter = () => {
    const newFilterValue = streamerPostFilter === '' ? '1' : '';
    setLocalStorage(STREAMER_FILTER_KEY, newFilterValue);
    setStreamerPostFilter(newFilterValue);
  };

  return {streamerPostFilter, toggleFilter};
};
